import React from 'react';
import { Col, Row } from 'tea-component';
import MentionsCharts from '../MentionsCharts';
import TimelineOfMentionsCharts from '../TimelineOfMentionsCharts';
import SentimentCharts from '../SentimentCharts';
import TimelineOfSentimentCharts from '../TimelineOfSentimentCharts';

export default function ChartsBox({
  data,
  loading,
  filter,
  dataType,
  lang,
  isVersion = false,
  gameInfoDetail,
  regionType,
}: any) {
  return (
    <Row>
      <Col span={12}>
        <MentionsCharts
          data={data}
          filter={filter}
          dataType={dataType}
          lang={lang}
          loading={loading}
          isVersion={isVersion}
          gameInfoDetail={gameInfoDetail}
          regionType={regionType}
          type="common-bar"
        ></MentionsCharts>
      </Col>
      <Col span={12}>
        <TimelineOfMentionsCharts
          data={data}
          filter={filter}
          lang={lang}
          dataType={dataType}
          loading={loading}
          isVersion={isVersion}
          regionType={regionType}
        ></TimelineOfMentionsCharts>
      </Col>
      <Col span={12}>
        <SentimentCharts
          data={data}
          filter={filter}
          dataType={dataType}
          lang={lang}
          loading={loading}
          isVersion={isVersion}
          regionType={regionType}
        ></SentimentCharts>
      </Col>
      <Col span={12}>
        <TimelineOfSentimentCharts
          data={data}
          filter={filter}
          dataType={dataType}
          lang={lang}
          loading={loading}
          isVersion={isVersion}
          regionType={regionType}
        ></TimelineOfSentimentCharts>
      </Col>
    </Row>
  );
}
